<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Customized Translation <br />Service for Professionals
              </h1>
              <p class="text-lead text-white">
                You can dramatically reduce the translation time
                <br />by using the fast and accurate AI translator <br />through
                the services.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Reset password</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div v-if="result">
                    <p class="text-center text-lead">
                      {{ result }}
                    </p>
                  </div>
                  <template v-else-if="authorization">
                    <base-input
                      class="mb-3"
                      prepend-icon="fas fa-id-badge"
                      placeholder="ID"
                      name="ID"
                      disabled
                      readonly
                      :value="id"
                    >
                    </base-input>
                    <base-input
                      alternative
                      class="mb-3"
                      prepend-icon="ni ni-lock-circle-open"
                      placeholder="New password"
                      successMessage="This password is available."
                      :type="showPassword ? 'type' : 'password'"
                      :append-icon="
                        `fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`
                      "
                      @click:append-icon="showPassword = !showPassword"
                      :bails="false"
                      name="Password"
                      rules="required|valid_password_english|valid_password_number|valid_password_special|valid_password_length"
                      v-model="pw"
                    >
                    </base-input>
                    <base-input
                      alternative
                      class="mb-3"
                      prepend-icon="ni ni-lock-circle-open"
                      placeholder="Confirm new password"
                      successMessage="The passwords match."
                      :type="showPasswordConfirm ? 'type' : 'password'"
                      :append-icon="
                        `fas ${showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'}`
                      "
                      @click:append-icon="
                        showPasswordConfirm = !showPasswordConfirm
                      "
                      rules="required"
                      name="PasswordConfirm"
                      mode="passive"
                      v-model="password_confirm"
                    >
                    </base-input>
                  </template>
                  <template v-else>
                    <base-input
                      alternative
                      class="mb-3"
                      prepend-icon="fas fa-id-badge"
                      placeholder="Email entered when registering as a member"
                      name="Email"
                      rules="required"
                      v-model="email"
                    >
                    </base-input>
                  </template>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                    >
                      {{ submitText }}
                    </base-button>
                  </div>
                  <div
                    class="invalid-feedback text-center"
                    style="display: block;"
                  >
                    {{ message }}
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/login" class="text-light" replace>
                <small>Back to login page</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <router-link to="/register" class="text-light">
                <small>Register</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: '',
      email: '',
      token: '',
      pw: '',
      password_confirm: '',
      result: '',
      completed: false,
      sended: false,
      message: '',
      showPassword: false,
      showPasswordConfirm: false,
    }
  },
  computed: {
    authorization() {
      return this.$route.query.token
    },
    submitText() {
      if (this.completed) return 'Back to login page'
      if (this.authorization) return 'Send'
      if (this.sended) return 'Resend Email'
      else return 'Receive password reset email'
    },
  },
  created() {
    this.fetchProfile()
  },
  methods: {
    async fetchProfile() {
      try {
        if (!this.authorization) return
        const response = await this.$slowbro.get('/me', {
          headers: { authorization: this.authorization },
        })
        this.id = response.data.id
      } catch (error) {
        this.result = 'An expired link or an invalid access.'
      }
    },
    async onSubmit() {
      if (this.completed) {
        this.$router.replace('/login')
      } else if (this.authorization) {
        this.resetPassword()
      } else {
        this.sendResetPasswordEmail()
      }
    },
    async sendResetPasswordEmail() {
      try {
        this.message = ''
        this.result = ''
        const { data } = await this.$slowbro.post('reset-password/send', {
          email: this.email,
        })
        this.sended = true
        this.result = `Password reset email has been sent to ${data.email}.`
      } catch (error) {
        this.message = error.response.data.message
      }
    },
    async resetPassword() {
      try {
        await this.$slowbro.post(
          '/reset-password/reset',
          { pw: this.pw },
          { headers: { authorization: this.authorization } }
        )
        this.result = 'The new password setting is complete.'
        this.completed = true
      } catch (error) {
        this.message = error.response.data.message
      }
    },
    checkPasswordConfirm() {
      const pw1 = this.pw
      const pw2 = this.password_confirm
      const error = (pw1 && pw2 && pw1 === pw2) || 'Passwords do not match.'
      this.$refs.formValidator.setErrors({
        PasswordConfirm: error === true ? [] : [error],
      })
    },
  },
  watch: {
    async pw() {
      if (this.password_confirm) {
        this.checkPasswordConfirm()
      }
    },
    async password_confirm() {
      this.checkPasswordConfirm()
    },
  },
}
</script>
